var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 22.6501C10.4599 22.6501 9.9899 22.5301 9.5499 22.2901C8.6699 21.8001 8.1399 20.9101 8.1399 19.9101V14.6101C8.1399 14.1101 7.8099 13.3601 7.4999 12.9801L3.7599 9.0201C3.1299 8.3901 2.6499 7.3101 2.6499 6.5001V4.2001C2.6499 2.6001 3.8599 1.3501 5.3999 1.3501H18.5999C20.1199 1.3501 21.3499 2.5801 21.3499 4.1001V6.3001C21.3499 7.3501 20.7199 8.5401 20.1299 9.1301L15.7999 12.9601C15.3799 13.3101 15.0499 14.0801 15.0499 14.7001V19.0001C15.0499 19.8901 14.4899 20.9201 13.7899 21.3401L12.4099 22.2301C11.9599 22.5101 11.4499 22.6501 10.9399 22.6501ZM5.3999 2.8501C4.6999 2.8501 4.1499 3.4401 4.1499 4.2001V6.5001C4.1499 6.8701 4.4499 7.5901 4.8299 7.9701L8.6399 11.9801C9.1499 12.6101 9.6499 13.6601 9.6499 14.6001V19.9001C9.6499 20.5501 10.0999 20.8701 10.2899 20.9701C10.7099 21.2001 11.2199 21.2001 11.6099 20.9601L12.9999 20.0701C13.2799 19.9001 13.5599 19.3601 13.5599 19.0001V14.7001C13.5599 13.6301 14.0799 12.4501 14.8299 11.8201L19.1099 8.0301C19.4499 7.6901 19.8599 6.8801 19.8599 6.2901V4.1001C19.8599 3.4101 19.2999 2.8501 18.6099 2.8501H5.3999Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1b60b8a44aae8051601493dfdbfc5d36.svg";
export { ForwardRef as ReactComponent };